export default {
  PERSONAL_DATA: 'PersonalData',
  ADDRESS: 'Address',
  IDENTIFICATION_DOCUMENT: 'IdentificationDocument',
  ACADEMIC_FORMATION: 'AcademicFormation',
  FINANCIAL_SPONSOR_PERSONAL_DATA: 'FinancialSponsorPersonalData',
  FINANCIAL_SPONSOR_IDENTIFICATION_DOCUMENT: 'FinancialSponsorIdentificationDocument',
  FINANCIAL_SPONSOR_ADDRESS: 'FinancialSponsorAddress',
  DOCUMENTS: 'SendDocuments',
  CONTRACT: 'Contract',
  PAYMENT: 'Payment',
  RESULT: 'Result',
  VALIDATE_LOGIN: 'ValidateLogin',
  ACCOUNTS: 'Accounts',
  ACCOUNTS_RESULT: 'AccountsResult',
};
